import codecs from './codecs';
import { LeanTypes } from './types';
export function transformToDocumentSchema(leanSchemaRoot, options) {
    return Object.assign(Object.assign({}, basicTransformToDocumentSchema(leanSchemaRoot)), { isDraftSchema: options.isDraft });
}
export function basicTransformToDocumentSchema(leanSchemaRoot) {
    const schema = codecs.shape.transformToDs({
        type: LeanTypes.shape,
        fieldsLeanSchema: leanSchemaRoot,
        required: true,
    });
    return Object.assign(Object.assign({}, schema), { isTopLevelDataNode: true });
}
//# sourceMappingURL=dsTransformer.js.map